import { createContext } from 'react';
import { initialState } from './initial-state';
import { AppContextValue } from '../types';

export const AppContext = createContext<AppContextValue>({
    state: initialState,
    changeState: () => {}
});
